<template>
    <div class="io-input" :style="grid ? `grid-area: ${name}` : ''">
        <MdField
            v-if="['checkbox', 'radio', 'switch'].indexOf(type) === -1"
            :class="{
                'bordered': outlined,
                'rounded': rounded,
                'md-invalid': input.error
            }"
        >
            <label v-if="['input', 'datepicker'].indexOf(type) !== -1">{{ label }}</label>
            <MdInput
                v-if="type === 'input'"
                :name="name"
                :value="input.value || value"
                @input="$emit('update', { value: $event, error: '' })"
            />
            <IoDatePicker
                v-if="type === 'datepicker'"
                :name="name"
                :selectedDate="input.value || value"
                :placement="placement"
                :mode="mode"
                @input="$emit('update', { value: $event, error: '' })"
            />
            <MdFile
                v-if="type === 'file'"
                :placeholder="label"
                :name="name"
                :accept="accept"
                :multiple="multiple"
                @md-change="$emit('update', { value: $event, error: '' })"
            />
            <span class="file-hint" v-if="hint">
                {{ hintText }}
                <span class="file-formats" v-if="type === 'file'">{{ accept.split(',').join(', ') }}</span>
            </span>
            <span class="md-error" v-show="input.error">{{ input.error }}</span>
        </MdField>
        <div v-if="type === 'checkbox'" class="input-checkbox">
            <input
                type="checkbox"
                class="form-check-input"
                :id="id"
                :name="name"
                :checked="input.value"
                @change="$emit('update', { value: !input.value ? 1 : 0, error: '' })"
            />
            <label class="form-check-label" :for="id">{{ label }}</label>
        </div>
        <div v-if="type === 'radio'" class="input-radio">
            <input
                type="radio"
                class="form-radio-input"
                :id="id"
                :name="name"
                :checked="input.value"
                @change="$emit('update', { value: !input.value ? { [name]: id } : 0, error: '' })"
            />
            <label class="form-radio-label" :for="id">{{ label }}</label>
        </div>
        <div v-if="type === 'switch'" class="input-switch">
            <IoSwitch
                :name="name"
                @change="$emit('update', { value: $event, error: '' })"
                :value="value"
                :switchValue="input.value || value"
                :label="label"
            />
        </div>
    </div>
</template>

<script>
import IoSwitch from './IoSwitch';

export default {
  name: 'IoInput',
  model: {
    prop: 'input',
    event: 'update',
  },
  components: {
    IoSwitch,
  },
  props: {
    input: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      required: true,
      type: [Number, String],
    },
    id: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'single',
    },
    placement: {
      type: String,
      default: 'right',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    hint: {
      type: Boolean,
      default: false,
    },
    hintText: {
      type: String,
      default: 'Erlaubte Dateiformate:',
    },
    error: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      validator(value) {
        return ['input', 'file', 'datepicker', 'checkbox', 'radio', 'switch'].indexOf(value) !== -1;
      },
      default: 'input',
    },
    accept: {
      type: String,
      default: '*',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    grid: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.input-checkbox {
    display: flex;
    align-items: center;

    .form-check-input {
        margin: initial;
        position: relative;
    }

    .form-check-label {
        padding-left: 1rem;
    }
}

.md-field {
    align-items: center;
    margin: 0;

    &.rounded {
        border-radius: 9999px !important;
    }

    &.bordered {
        border: 1px solid #dee2e6;
    }

    &:not(.md-has-textarea).bordered {
        padding: 20px 32px 0 32px;
        height: 65px;

        &.md-focused,
        &.md-has-value {
            label {
                top: 4px;
            }
        }

        label {
            left: 32px;
        }
    }
}

.io-datepicker {
    :deep(input) {
        border: none;
        box-shadow: none;
        padding: 0;
    }
}
</style>
